import { request } from 'data/requests/request';

import { IBuyBackCartConfig, IBuyBackConfig, IBuyBackProduct } from 'components/BuyBack/interfaces/buyBackInterfaces';

export interface IBuyBackCartConfigResponse {
    modalConfig: IBuyBackConfig;
    cartConfig: IBuyBackCartConfig;
}

const GetBuyBackCartConfigRequest = () =>
    request({
        type: 'buyBackCartConfig',
        url: `buyback/ajax/cartconfig`,
        method: 'GET',
        force: true,
        notApi: true,
    });

export default GetBuyBackCartConfigRequest;
